
$(document).on('change', `.js-eq-quiz-product-page-form [data-option-1], .js-eq-quiz-product-page-form [data-option-2],.js-eq-quiz-product-page-form [data-option-3]`, function (e) {
    let option1 = option2 = option3 = null;
   
    let parent = $(this).closest('.eq-quiz-box');
    
    if (parent.find(`.js-eq-quiz-product-page-form [data-option-1]`).length > 0) {
       option1 = parent.find(`.js-eq-quiz-product-page-form [data-option-1] option:selected`).val();
    }
    if (parent.find(`.js-eq-quiz-product-page-form [data-option-2]`).length > 0) {
       option2 = parent.find(`.js-eq-quiz-product-page-form [data-option-2] option:selected`).val();
    }
    if (parent.find(`.js-eq-quiz-product-page-form [data-option-3]`).length > 0) {
       option3 = parent.find(`.js-eq-quiz-product-page-form [data-option-3] option:selected`).val();
    }
    let variant_id = null;
    let current_selected_option = null;
    if (option2 == null & option3 == null) {

       current_selected_option = parent.find(`.js-eq-quiz-product-page-form select.actual-variants option[data-option1='${option1}']`);
       variant_id = parent.find(`.js-eq-quiz-product-page-form select.actual-variants option[data-option1='${option1}']`).val();
    }
    if (option2 != null & option3 == null) {

       current_selected_option = parent.find(`.js-eq-quiz-product-page-form select.actual-variants option[data-option1='${option1}'][data-option2='${option2}']`);
       variant_id = parent.find(`.js-eq-quiz-product-page-form select.actual-variants option[data-option1='${option1}'][data-option2='${option2}']`).val();
    }
    if (option2 != null & option3 != null) {

       current_selected_option = parent.find(`.js-eq-quiz-product-page-form select.actual-variants option[data-option1='${option1}'][data-option2='${option2}'][data-option3='${option3}']`);
       variant_id = parent.find(`.js-eq-quiz-product-page-form select.actual-variants option[data-option1='${option1}'][data-option2='${option2}'][data-option3='${option3}']`).val();
    }
    if (variant_id == null) {
       $(`.js-eq-quiz-product-page-form .stock`).fadeOut(100);
       $(`.js-eq-quiz-product-page-form .js-out-stock`).fadeIn(100);
       $(`.js-eq-quiz-product-page-form .product_page_atc`).addClass('soldout');
       $(`.js-eq-quiz-product-page-form .product_page_atc span`).text("Unavailable");
       return true;
    }
    let price = $(current_selected_option).attr('data-price');
    let is_available = $(current_selected_option).attr('data-available');
    parent.find(`.js-eq-quiz-product-page-form select.actual-variants`).val(variant_id).trigger('change'); 
    // $(`.js-eq-quiz-product-page-form .js-compare-price`).text(compare_at_price);
    parent.find(`.eq-quiz-otp-price`).text(price);
    if (is_available == 'true') {
        parent.find(`.eq-quiz-atc `).html(`<img src="//joyorganics.com/cdn/shop/files/eq-product-btn-cart-icon_250x.png?v=9807713154866607732" alt="cart icon"> <span>Add to cart</span>`);
        parent.find(`.eq-quiz-atc`).css("pointer-events", "all");
        parent.find(`.eq-quiz-atc`).css("opacity", "1");
    } else {
        parent.find(`.eq-quiz-atc`).css("pointer-events", "none");
        parent.find(`.eq-quiz-atc`).css("opacity", "0.5");
        parent.find(`.eq-quiz-atc`).html("Soldout");
        parent.find(`.eq-quiz-atc`).css("color", "#fff");
    }
 });

 $(document).on('click', '.eq-quiz-atc', function (e) {
    e.preventDefault();
    let parent = $(this).closest('.eq-quiz-box');
    let variantId = parent.find('.js_product_var_change option:selected').val();
    let customFlavor = parent.find('select[name="custom-flavor"]').val();
    let customStrength = parent.find('.custom-meta-strength option:selected').val();
    let qty = 1;
    let data = {};
    data = {
        id: variantId,
        quantity: qty,
        properties: {
         'Strength': customStrength,
         'Flavor': customFlavor
     }
     }; 
    $.ajax({
       url: "/cart/add.js",
       method: "POST",
       data: data,
       dataType: "json",
       success: function (data) {
          // window.location = "/cart";
       },
       error: function (xhr, status, error) {
          console.error("Error adding to cart:", error);
          console.error("Response Text:", xhr.responseText);
          window.alert(xhr.responseJSON.description);
       }
    });
 });